export default {
    _prefix: "FormOutline",
    labels: {
        questionCount: (data: { questionCount: number }) =>
            "{{questionCount}} Question(s)",
        newQuestion: "New Question",
        newQuestionGroup: "New Question Group",
        icon: "Redirect to Question Level View",
    },
    indices: {
        questionIndex: (data: { level: number; subIndex: number }) =>
            "{{level}}.{{subIndex}}",
    },
};
